<template>
  <div class="modal-overlay" v-if="isVisible" @click.self="close">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('buyNumberModal.title') }}</h4>
          <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ $t('buyNumberModal.description') }}</p>

          <ul class="seller-info">
            <li><strong>{{ $t('buyNumberModal.seller_name') }}</strong> {{ product.username }}</li>
            <li v-if="memberSince"><strong>{{ $t('buyNumberModal.member_since') }}</strong> {{ memberSince }}</li>
            <li><strong>{{ $t('buyNumberModal.seller_type') }}</strong> {{ userTypeText }}</li>
            <li><strong>{{ $t('buyNumberModal.last_update') }}</strong> {{ lastUpdateText }}</li>
          </ul>

          <div class="price-display">
            {{ $t('buyNumberModal.payable_amount') }} <strong>{{ formatNumber(planPrice) }}</strong> {{ $t('details.currency') }}
            <div class="locale-price" v-if="currency.shouldShowCurrency && currency.formattedLocalePrice && !currency.currencyLoading">
              <span class="locale-label">{{ currency.localeCode }}</span>
              <span class="locale-value">{{ currency.formattedLocalePrice }}</span>
            </div>
          </div>

          <hr />

          <div class="info-box">
            <p><strong>{{ $t('buyNumberModal.why_pay') }}</strong></p>
            <p>{{ $t('buyNumberModal.why_pay_desc') }}</p>
            <p>{{ $t('buyNumberModal.refund_note') }}</p>
            <p>{{ $t('buyNumberModal.company_note') }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <div class="trust-logos">
            <a target="_blank" href="https://creativehousenet.ir/web/creative" class="trust-logo" :title="$t('buyNumberModal.trust_danesh_bonyan')">
              <img :src="`${baseURL}img/danesh-bonyan.png`" :alt="$t('buyNumberModal.trust_danesh_bonyan')" />
            </a>
            <a target="_blank" href="//ecunion.ir/verify/sarvban.com?token=5293549609b9e4d168f5" class="trust-logo" :title="$t('buyNumberModal.trust_ecunion')">
              <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+" :alt="$t('buyNumberModal.trust_ecunion')" />
            </a>
            <a target="_blank" href="https://trustseal.enamad.ir/?id=156458&amp;Code=UHh1Z9hVzXIWQq9EHeQg" class="trust-logo" :title="$t('buyNumberModal.trust_enamad_title')">
              <img :src="`${baseURL}img/star1.png`" :alt="$t('buyNumberModal.trust_enamad_alt')" />
            </a>
            <a target="_blank" href="https://vastraholding.com/" class="trust-logo" style="background-color: #333;" :title="$t('buyNumberModal.trust_vastra_title')">
              <img :src="`${baseURL}img/Vastra_logonew_final-01.png`" :alt="$t('buyNumberModal.trust_vastra_alt')" />
            </a>
            <a target="_blank" href="https://logo.samandehi.ir/Verify.aspx?id=1014100&amp;p=rfthgvkaobpdjyoejymc" class="trust-logo" :title="$t('buyNumberModal.trust_samandehi')">
              <img :src="`${baseURL}img/samandehi.png`" :alt="$t('buyNumberModal.trust_samandehi')" />
            </a>
          </div>
          <div class="btn-row">
            <button type="button" class="btn btn-primary" @click="handlePay">{{ $t('buyNumberModal.pay') }}</button>
            <button type="button" class="btn btn-outline-primary" @click="close">{{ $t('buyNumberModal.close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getBuyNumberPlanType, getBuyNumberPlanPrice, getMemberSince, formatDaysPassedLabel } from '~/utils/buy-number'
import { formatFaNumber } from '~/utils/format'
import { useCurrencyConversion } from '@/composables/useCurrencyConversion'
const baseURL = useRuntimeConfig().app.baseURL
const { t } = useI18n()
const props = defineProps({
  product: { type: Object, required: true },
  userTypeText: { type: String, default: '' }
})
const emit = defineEmits(['close'])

const isVisible = ref(true)
const isSubmitting = ref(false)
const auth = useAuth()
const currentUser = computed(() => auth.user?.value || null)

const planType = computed(() => getBuyNumberPlanType(props.product))

const planPrice = computed(() => getBuyNumberPlanPrice(props.product))

const userTypeText = computed(() => {
  if (props.product?.hot) return t('buyNumberModal.special_seller')
  return props.userTypeText || t('details.seller_type')
})

const memberSince = computed(() => getMemberSince(props.product))

const lastUpdateText = computed(() => {
  const { isToday, days } = formatDaysPassedLabel(props.product?.daysPassed || 0)
  return isToday ? t('buyNumberModal.today') : `${days} ${t('buyNumberModal.days_ago')}`
})

const close = () => {
  isVisible.value = false
  emit('close')
}
const toast = useToast()

const handlePay = async () => {
  if (!currentUser.value) {
    alert(t('buyNumberModal.login_required'))
    return
  }

  if (window._paq) {
    window._paq.push(['trackEvent', 'Buy Number', 'buynum-click'])
  }

  isSubmitting.value = true
  try {
    const response = await $fetch('/market/api/payment', {
      method: 'POST',
      body: {
        adv_id: props.product.id,
        plan_type: planType.value,
      }
    })

    if (auth.handleSessionExpired(response)) return

    if (response.pay_url) {
      window.location.href = response.pay_url
    } else if (response.status) {
      toast.success(t('buyNumberModal.success'), { timeout: 5000 })

      // alert(t('buyNumberModal.success'))
      close()
    } else {
      toast.add({
        title: `${response.message || t('buyNumberModal.error')}`,
        description: '',
        color: 'red',
        icon: 'i-heroicons-exclamation-circle',
        timeout: 15000,
      })

    }
  } catch (e) {
    if (auth.handleSessionExpired(e)) return
    console.error('Payment error:', e)
      toast.add({
        title: `${response.message || t('buyNumberModal.error')}`,
        description: '',
        color: 'red',
        icon: 'i-heroicons-exclamation-circle',
        timeout: 15000,
      })
  } finally {
    isSubmitting.value = false
  }
}
const formatNumber = (num) => formatFaNumber(num)

// Currency conversion
const currency = useCurrencyConversion(props.product)

// Locale-specific formatted price
const formattedLocalePrice = computed(() => currency.formattedLocalePrice.value)

</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
}

.modal-dialog {
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.modal-content {
  background: #fff;
  border-radius: $r-lg;
  overflow: hidden;
  box-shadow: $shadow-warm-lg;
}

@media (max-height: 640px) {
  .modal-dialog {
    margin: auto;
    max-height: 95vh;
  }
  .modal-content {
    overflow-y: auto;
    max-height: 95vh;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid $line;

  .modal-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 700;
    color: $ink;
  }

  .btn-close {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s;
    &:hover { opacity: 1; }
  }
}

.modal-body {
  padding: 20px;
  font-size: 0.88rem;
  line-height: 1.8;
  color: $ink;

  > p {
    margin: 0 0 14px;
    font-weight: 500;
  }

  .seller-info {
    margin: 0 0 16px;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: $r-md;
    border: 1px solid $line;
    list-style: none;

    li {
      padding: 4px 0;
      font-size: 0.85rem;

      strong { font-weight: 700; color: $ink; }
    }
  }

  .price-display {
    text-align: center;
    padding: 12px;
    background: rgba(3, 160, 84, 0.06);
    border-radius: $r-md;
    font-size: 1.2rem;
    font-weight: 500;

    strong {
      color: $leaf;
      font-size: 1.2rem;
    }

    .locale-price {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-top: 8px;
      padding: 8px 12px;
      background: linear-gradient(135deg, $leaf, $leaf-soft);
      border-radius: $r-pill;
      color: #fff;
      font-size: 0.95rem;
      font-weight: 700;
      box-shadow: 0 4px 12px rgba(3, 160, 84, 0.25);

      .locale-label {
        font-size: 0.7rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        opacity: 0.9;
      }

      .locale-value {
        font-size: 1rem;
        font-weight: 800;
      }
    }

    .locale-loading {
      margin-top: 8px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 0.8rem;
      color: $ink-soft;

      i { color: $leaf; }
    }
  }

  hr {
    border: none;
    border-top: 1px solid $line;
    margin: 16px 0;
  }

  .info-box {
    font-size: 0.78rem;
    line-height: 1.7;
    color: $ink-soft;

    p {
      margin: 0 0 8px;

      &:last-child { margin-bottom: 0; }
    }

    strong { color: $ink; }
  }
}

.modal-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid $line;

  .trust-logos {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    padding-bottom: 10px;
    border-bottom: 1px solid $line;
  }

  .trust-logo {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: $r-sm;
    overflow: hidden;
    border: 1px solid $line;
    transition: all 0.25s;
    opacity: 0.85;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &:hover {
      opacity: 1;
      border-color: $leaf;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    }
  }

  .btn-row {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .btn {
    padding: 8px 18px;
    border-radius: $r-pill;
    padding: 8px 40px;
    font-size: 0.84rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: all 0.25s;
    border: 1.5px solid;

    &.btn-primary {
      background: $leaf;
      border-color: $leaf;
      color: #fff;

      &:hover { background: $leaf-deep; border-color: $leaf-deep; }
      &:active { transform: scale(0.97); }
    }

    &.btn-outline-primary {
      background: transparent;
      border-color: $leaf;
      color: $leaf;

      &:hover { background: $leaf; color: #fff; }
      &:active { transform: scale(0.97); }
    }
  }
}
</style>
